
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./marshal.cjs.production.min.js')
} else {
  module.exports = require('./marshal.cjs.development.js')
}
